import React from 'react';
import { InputWrapper, FieldDescription } from './Input.styles';

const CustomInputComponent = (FieldComponent, inline) => ({
  field, // { name, value, onChange, onBlur }
  fieldDefinition,
  lookupData,
  sideEffectHandler,
  form: {
    touched, errors, setFieldValue, values,
  },
}) => (
  <InputWrapper mb={3} inline={inline}>
    <label htmlFor={fieldDefinition.key}>
      {fieldDefinition.label}
    </label>
    {fieldDefinition.description && (
      <FieldDescription mb={1}>
        {fieldDefinition.description}
      </FieldDescription>
    )}
    <FieldComponent
      lookupData={lookupData}
      fieldDefinition={fieldDefinition}
      field={field}
      values={values}
      setFieldValue={setFieldValue}
      sideEffectHandler={sideEffectHandler}
    />
    {touched[field.name]
    && errors[field.name] && <div className="error">{errors[field.name]}</div>}
  </InputWrapper>
);

export default CustomInputComponent;
